/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
import { NamedNode } from '../models.js';
import { Prefix } from '../utils/Prefix.js';
var base = 'http://www.w3.org/2000/01/rdf-schema#';
export var _ontologyResource = NamedNode.getOrCreate(base);
Prefix.add('rdfs', base);
export var subPropertyOf = NamedNode.getOrCreate(base + 'subPropertyOf');
var subClassOf = NamedNode.getOrCreate(base + 'subClassOf');
var range = NamedNode.getOrCreate(base + 'range');
var isDefinedBy = NamedNode.getOrCreate(base + 'isDefinedBy');
var label = NamedNode.getOrCreate(base + 'label');
var comment = NamedNode.getOrCreate(base + 'comment');
var Literal = NamedNode.getOrCreate(base + 'Literal');
var Datatype = NamedNode.getOrCreate(base + 'Datatype');
var Class = NamedNode.getOrCreate(base + 'Class');
var Resource = NamedNode.getOrCreate(base + 'Resource');
export const rdfs = {
    _ontologyResource,
    subPropertyOf,
    subClassOf,
    range,
    isDefinedBy,
    label,
    comment,
    Literal,
    Datatype,
    Class,
    Resource,
};
//# sourceMappingURL=rdfs.js.map